import { createTheme } from '@mui/material';
import { colors } from './theme';
export const muiTheme = createTheme({
  zIndex: {
    // This z-index is used by MUI dropdowns (e.g. Filter menu). This change
    // prevents them from appearing on top of modals during animations.
    // See https://avbsupport.atlassian.net/browse/HUB-5706
    modal: 0
  },
  // Used by MUI X date and time pickers
  palette: {
    primary: {
      main: colors.palettes.primary.main,
      dark: colors.palettes.primary.main,
      contrastText: colors.palettes.primary.contrastText
    }
  },
  typography: {
    fontFamily: 'inherit'
  }
});